import createIcon from '../../createIcon';

/**
 * @component @name Monitor
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgM0g0QzIuOSAzIDIgMy45IDIgNVYxNkMyIDE3LjEgMi45IDE4IDQgMThIN0w2IDE5VjIxSDE4VjE5TDE3IDE4SDIwQzIxLjEgMTggMjIgMTcuMSAyMiAxNlY1QzIyIDMuOSAyMS4xIDMgMjAgM1pNMjAgMTZINFY1SDIwVjE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Monitor = createIcon('Monitor', [
  [
    'path',
    {
      d: 'M20 3H4C2.9 3 2 3.9 2 5V16C2 17.1 2.9 18 4 18H7L6 19V21H18V19L17 18H20C21.1 18 22 17.1 22 16V5C22 3.9 21.1 3 20 3ZM20 16H4V5H20V16Z',
      key: '1vrd75',
    },
  ],
]);

export default Monitor;
